import createEnum from 'lib/createEnum';

export const CUSTOMER_TYPING_STATE_UPDATED = 'session/CUSTOMER_TYPING_STATE_UPDATED';
export const SESSION_CREATE = 'session/SESSION_CREATE';
export const SESSION_CREATE_SUCCESS = 'session/SESSION_CREATE_SUCCESS';
export const SESSION_CREATE_ERROR = 'session/SESSION_CREATE_ERROR';
export const SESSION_UPDATE_SUCCESS = 'session/SESSION_UPDATE_SUCCESS';
export const SESSION_SET_WELCOME_MESSAGE = 'session/SET_WELCOME_MESSAGE';
export const SESSION_FETCH_SUCCESS = 'session/SESSION_FETCH_SUCCESS';
export const SESSION_UPDATE_URL = 'session/SESSION_UPDATE_URL';

// session statuses
export const SessionStatus = createEnum('NEW', 'LOADING', 'SAVED', 'SAVING', 'ENDED');

// ended reasons
export const EndedReason = createEnum('AGENT_ENDED', 'CONSUMER_NO_REPLY', 'TIME_EXPIRED', 'NEW_SESSION_STARTED');

// agent typing timeout duration in seconds
export const AGENT_TYPING_TIMEOUT = 15;

// typing states
export const TypingState = createEnum('STARTED', 'PAUSED', 'STOPPED');
